import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function searchReducer(state = initialState.search, action) {
  //avoiding state mutation, while updating nested states.
  switch (action.type) {
    case types.LOAD_SEARCH_AUTOCOMPLETE_DATA:
      return Object.assign({}, state, {
        options: action.data,
      });
    case types.SET_SELECTEDSEARCH_OPTION:
      return Object.assign({}, state, {
        selectedOption: action.data,
      });
    case types.SET_SEARCH_TERM:
      return Object.assign({}, state, {
        searchTerm: action.data,
      });
    case types.SET_SEARCH_CATEGORY:
      return Object.assign({}, state, {
        category: action.data,
      });
    case types.RESET_SEARCH_SEARCHTERM:
      return Object.assign({}, state, {
        searchTerm: "",
      });
    default:
      return state;
  }
}
